import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const FormLabel = ({ htmlFor, label, optional, className, id, forwardRef, onClick }) => (
  <label ref={forwardRef} htmlFor={htmlFor} className={cx(styles.label, className)} onClick={onClick} id={id}>
    {label}
    <If condition={optional}>
      <span className={styles.optional}>(optional)</span>
    </If>
  </label>
)

FormLabel.propTypes = {
  htmlFor: PropTypes.string,
  label: PropTypes.string.isRequired,
  optional: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  forwardRef: PropTypes.any,
  onClick: PropTypes.func,
}

export default FormLabel
